import { useCallback, useContext } from 'react';
import { FarmContext } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/FarmContextProvider';

export function useFarmPath() {
    const { farm } = useContext(FarmContext);

    return useCallback(
        (to: string) => {
            return `/${farm.id}${to}`;
        },
        [farm.id],
    );
}
